<dashboardnav>
  
    <cradua-encroachmenttype
    [encroachmenttypes]="encroachmenttypes$ | async"
    (encroachmenttype)="onSubmitEncroachmentType($event)"
    (deleteEncroachmentTypeEvent)="onDeleteEncroachmentType($event)"
    *ngIf="(isLoading$ | async ) === false"
    >
  </cradua-encroachmenttype>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  